import { render, staticRenderFns } from "./EditShapesMap.vue?vue&type=template&id=9a70b1b0&scoped=true&"
import script from "./EditShapesMap.vue?vue&type=script&lang=ts&"
export * from "./EditShapesMap.vue?vue&type=script&lang=ts&"
import style0 from "./EditShapesMap.vue?vue&type=style&index=0&id=9a70b1b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a70b1b0",
  null
  
)

export default component.exports